import { Input, Select } from "components";
import { useGroupList } from "pages/Inventori/Register/ItemBuild/utils";
import { PaginationType } from "..";
import { debounce } from "lodash";

export function FilterSetItem(props: {
    pagination: PaginationType;
    handleSearch: (value: string) => void;
    handleGroup: (value: any) => void;
}) {
    const { data, isLoading } = useGroupList();

    const onDebounce = debounce((e: any) =>
        props.handleSearch(e.target.value)
      );

    return (
        <div className="flex items-center justify-between">
            <div>
                <Input
                    label="SEARCH"
                    className="w-[300px]"
                    placeholder="Search data..."
                    onChange={onDebounce}
                />
            </div>

            <div>
                <Select
                    label="PRODUCT GROUP"
                    placeholder="Select product group"
                    className="w-[300px]"
                    options={data}
                    isLoading={isLoading}
                    onChange={e => props.handleGroup(e?.value)}
                />
            </div>
        </div>
    );
}
